import { render, staticRenderFns } from "./FeedBackLink.vue?vue&type=template&id=268fd436&scoped=true&lang=pug&"
var script = {}
import style0 from "./FeedBackLink.vue?vue&type=style&index=0&id=268fd436&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fd436",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('268fd436')) {
      api.createRecord('268fd436', component.options)
    } else {
      api.reload('268fd436', component.options)
    }
    module.hot.accept("./FeedBackLink.vue?vue&type=template&id=268fd436&scoped=true&lang=pug&", function () {
      api.rerender('268fd436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feed_back/FeedBackLink.vue"
export default component.exports